import React from 'react'
import { formatEuro } from '../../lib/calcoli'
import { DURATE_STANDALONE } from '../../lib/validazioni'

// data.standalone_selezionati e' un array di { codice, anni }

export default function StepStandalone({ data, update, prodotti, ruoloUtente }) {
  const lista = data.standalone_selezionati || []
  const isSubagente = ruoloUtente === 'subagente'

  function findIdx(codice) {
    return lista.findIndex(x => x.codice === codice)
  }

  function toggle(codice) {
    const i = findIdx(codice)
    if (i >= 0) {
      const next = lista.filter((_, j) => j !== i)
      update({ standalone_selezionati: next })
    } else {
      update({ standalone_selezionati: [...lista, { codice, anni: 1 }] })
    }
  }

  function setAnni(codice, anni) {
    if (isSubagente) return  // forzato a 1
    const i = findIdx(codice)
    if (i < 0) return
    const next = [...lista]
    next[i] = { ...next[i], anni: parseInt(anni) }
    update({ standalone_selezionati: next })
  }

  return (
    <div>
      <div className="info-box mt-1" style={{ marginBottom: '1.5rem' }}>
        Garanzie stand alone vendibili indipendentemente dalla CVT. Premio annuo fisso × anni di durata (1–5).
        {isSubagente && <><br/><strong>Subagente:</strong> puoi vendere stand alone solo a durata 1 anno.</>}
      </div>
      {prodotti.length === 0 ? (
        <p className="text-muted">Nessun prodotto stand alone configurato.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {prodotti.map(p => {
            const i = findIdx(p.codice)
            const sel = i >= 0
            const anni = sel ? lista[i].anni : 1
            const totale = parseFloat(p.prezzo_annuo) * anni
            return (
              <div key={p.codice} className={`check-row ${sel ? 'checked' : ''}`}
                   style={{ flexWrap: 'wrap', gap: 12 }}>
                <input type="checkbox" checked={sel} onChange={() => toggle(p.codice)} />
                <label style={{ flex: 1, cursor: 'pointer' }} onClick={() => toggle(p.codice)}>
                  <strong>{p.nome}</strong>
                  {p.partner && <span className="text-muted text-small"> · {p.partner}</span>}
                  <div className="text-small text-muted">{formatEuro(p.prezzo_annuo)}/anno</div>
                </label>
                {sel && (
                  isSubagente ? (
                    <span className="text-small text-muted" style={{ minWidth: 110 }}>1 anno</span>
                  ) : (
                    <select value={anni} onChange={e => setAnni(p.codice, e.target.value)}
                            onClick={e => e.stopPropagation()} style={{ width: 110 }}>
                      {DURATE_STANDALONE.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                    </select>
                  )
                )}
                <span style={{ fontWeight: 500, minWidth: 100, textAlign: 'right' }}>
                  {sel ? formatEuro(totale) : '—'}
                </span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
